module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7GasX"))).then(() => parcelRequire('iDabs'));